export default "__VITE_ASSET__BOn6Bxax__"